import { faMicrophone, faStopCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@material-ui/core";
import { LinearProgress } from "@mui/material";
import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  ChatContainer,
  InputToolbox,
  MainContainer,
  MessageInput,
  MessageList,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
export default function CrucialWhisper({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [feedbackResponses, setFeedbackResponses] = useState([]);
  const [deleteError, setdeleteError] = useState("");
  // const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  // const [modeltext, setModelText] = useState("LLAMA 13b");
  const [userName, setUsername] = useState("");
  const timetaken = useRef(0);

  // const [text, setText] = useState("");
  // const [isSpeaking, setIsSpeaking] = useState(false);
  // const handleOnRecord = () => {
  //   setIsSpeaking(true);
  //   const SpeechRecognition =
  //     window.SpeechRecognition || window.webkitSpeechRecognition;
  //   const recognition = new SpeechRecognition();

  //   recognition.onresult = async (event) => {
  //     const transcript = event.results[0][0].transcript;
  //     console.log("event", event);
  //     setText(transcript);
  //   };

  //   recognition.start();
  // };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [transcript, setTranScript] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const messagesEndRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isStartChatStarted, setIsStartChatStarted] = useState(false);

  const [openPopup, setOpenPopup] = useState(true);
  const handleClosePopup = () => setOpenPopup(false);
  // calculate progress
  const calculateProgress = (flags, currentProgress) => {
    let progress = currentProgress;

    // Safely check if user_response is a string before using string methodsrogress += 20;
    // Increment progress only after the second response
    // if (flags.question_1_count === 1 && progress < 20) {
    //   setTimeout(() => {
    //     progress += 20; // Increment progress after a delay
    //     console.log("Progress increased to: ", progress);
    //     // You can call a function here to update the progress in the UI if needed
    //     setProgress(progress); // Assuming setProgress is your state updater function
    //   }, 5000); // 2000ms = 2 seconds delay (you can adjust this value)
    // }
    if (flags.question_1_count === 1 && progress < 20) progress += 20;
    if (flags.activity_2_condition && progress < 40) progress += 20;
    if (
      flags.activity_3_1st_condition &&
      flags.question_activity === 1 &&
      progress < 60
    )
      progress += 20;
    if (flags.activity_3_2nd_condition && progress < 60) progress += 20;
    if (flags.activity_4_2nd_condition && progress < 80) progress += 20;

    return progress;
  };

  // useEffect(() => {
  //   const messageList = messagesEndRef.current?.parentNode;
  //   if (messageList) {
  //     messageList.scrollTop = messageList.scrollHeight;
  //   }
  // }, [messages]);

  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]; // Get the last message

      const messageList = messagesEndRef.current?.parentNode;
      if (messageList) {
        if (lastMessage.direction === "incoming") {
          // Apply the 3-second delay for incoming messages
          setTimeout(() => {
            messageList.scrollTop = messageList.scrollHeight;
          }, 3000);
        } else {
          // No delay for outgoing messages
          messageList.scrollTop = messageList.scrollHeight;
        }
      }
    }
  }, [messages]);

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    let email =
      jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2][
        "Value"
      ];
    email.includes("genai2244") ? setgenaiaccess(true) : setgenaiaccess(false);

    if (userdata) {
      setUsername(username);
    }
  }, []);

  const handleSendMessage = (messageText, inputId) => {
    if (messageText.trim() === "") {
      return;
    }
    // if (currentPayload.activity_4_condition === true) {
    //   messageText = `Manager: ${messageText}`;
    // }
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(),
      text: messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion1(messageText);
  };

  const handleStart = async () => {
    setIsStartChatStarted(true);
    console.log("Handle Start is calling");

    // Reset any previous conversation and disable input field during loading
    setMessages([]);
    setIsInputDisabled(true);
    setAnswerload(true);
    setTranScript("");
    setDisplayText("");
    setFeedbackResponses([]);
    setProgress(0);

    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

    // Reset the current payload for a fresh start
    const resetPayload = {
      conversation_list: [], // Clear conversation history
      users_response: "",
      welcome_message_event: true,
      start_activity: false,
      activity_1_condition: true,
      activity_2_condition: false,
      activity_3_condition: false,
      activity_4_condition: false,
      response: "",
      feedback: "",
      question_activity: false,
      response_activity: false,
      well_response: false,
      could_do_better_response: false,
      activity_2_responses_list: [],
      activity_3_1st_condition: false,
      index_of_question_answer: 0,
      activity_3_3rd_condition: false,
      activity_3_2nd_condition: false,
      conversation_history_list: [],
      activity_4_1st_condition: false,
      activity_4_2nd_condition: false,
      activity_4_condition: false,
      count: 0,
      evaluation_list: [],
      first_response: false,
      question_1_count: 0,
      satisfaction_condition: false,
    };

    // Prepare the initial payload
    // const initialPayload = {
    //   ...resetPayload,
    //   users_response: "",
    //   welcome_message_event: true,
    // };

    setCurrentPayload(resetPayload);
    // setCurrentPayload(initialPayload);
    console.log("Initial Payload before sending:", resetPayload);

    try {
      // Send a POST request to the backend with the initial payload
      const response = await fetch(
        "https://h6de6x6e4ova4ubumwtz3cyybm0higet.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(resetPayload), // Send the reset payload
        },
      );

      const data = await response.json();
      console.log("First Response data:", data);

      // Update the messages with the backend response (e.g., welcome message)
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          text: `Welcome ${userName}, ` + data.message.response,
          direction: "incoming",
        },
      ]);

      // Update currentPayload with the new data from the backend
      // setCurrentPayload((prevPayload) => ({
      //   ...prevPayload,
      //   // Update flags based on backend response
      //   welcome_message_event: data.welcome_message_event || false,
      //   start_activity: data.start_activity || prevPayload.start_activity,
      //   activity_1_condition:
      //     data.activity_1_condition || prevPayload.activity_1_condition,
      //   activity_2_condition:
      //     data.activity_2_condition || prevPayload.activity_2_condition,
      //   question_activity:
      //     data.question_activity || prevPayload.question_activity,
      //   response_activity:
      //     data.response_activity || prevPayload.response_activity,
      //   conversation_list: [...prevPayload.conversation_list, data.response],
      // }));

      setCurrentPayload((prevPayload) => ({
        ...prevPayload,
        ...data.message,
      }));

      setAnswerload(false);
      setIsInputDisabled(false);
    } catch (error) {
      console.error("Error fetching initial message:", error);

      // Stop loading and allow retry
      setAnswerload(false);
      setIsInputDisabled(false);
    }
  };

  const [currentPayload, setCurrentPayload] = useState({
    conversation_list: [],
    users_response: "",
    welcome_message_event: true,
    start_activity: false,
    activity_1_condition: true,
    activity_2_condition: false,
    activity_3_condition: false,
    activity_4_condition: false,
    response: "",
    feedback: "",
    question_activity: false,
    response_activity: false,
    well_response: false,
    could_do_better_response: false,
    activity_2_responses_list: [],
    activity_3_1st_condition: false,
    index_of_question_answer: 0,
    activity_3_3rd_condition: false,
    activity_3_2nd_condition: false,
    conversation_history_list: [],
    activity_4_1st_condition: false,
    activity_4_2nd_condition: false,
    activity_4_condition: false,
    count: 0,
    evaluation_list: [],
    first_response: false,
    question_1_count: 0,
    satisfaction_condition: false,
  });

  // const handleQuestion1 = async (question) => {
  //   setTranScript("");
  //   setDisplayText("");

  //   if (question.length > 0) {
  //     timetaken.current = 0;

  //     // Start the timer to track time taken for the request
  //     let time = setInterval(() => {
  //       timetaken.current = parseFloat(timetaken.current) + 0.1;
  //     }, 100);

  //     setAnswerload(true);
  //     console.log("requesting");

  //     // Get the username
  //     const username = localStorage.getItem(
  //       "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser"
  //     );

  //     // Update the payload with the new question and conversation list
  //     const updatedPayload = {
  //       ...currentPayload,
  //       conversation_list: [...currentPayload.conversation_list, question],
  //       users_response: question,
  //     };

  //     console.log("Payload being sent in the second request:", updatedPayload);

  //     try {
  //       // Fetch the response from the backend
  //       const response = await fetch(
  //         "https://h6de6x6e4ova4ubumwtz3cyybm0higet.lambda-url.ap-south-1.on.aws/",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(updatedPayload), // Send the updated payload
  //         }
  //       );

  //       const data = await response.json();
  //       console.log("Second Response Data:", data);

  //       setAnswerload(false);
  //       const chatbotMessage = data.message.response || "No message available";
  //       const chatbotConclusion = data.feedback || "";

  //       // If the response contains flags like welcome_message_event and start_activity, update them in the payload
  //       const updatedFlags = {
  //         welcome_message_event:
  //           data.welcome_message_event !== undefined
  //             ? data.welcome_message_event
  //             : currentPayload.welcome_message_event,
  //         start_activity:
  //           data.start_activity !== undefined
  //             ? data.start_activity
  //             : currentPayload.start_activity,
  //         activity_1_condition:
  //           data.activity_1_condition !== undefined
  //             ? data.activity_1_condition
  //             : currentPayload.activity_1_condition,
  //         activity_2_condition:
  //           data.activity_2_condition !== undefined
  //             ? data.activity_2_condition
  //             : currentPayload.activity_2_condition,
  //         activity_3_condition:
  //           data.activity_3_condition !== undefined
  //             ? data.activity_3_condition
  //             : currentPayload.activity_3_condition,
  //         question_activity:
  //           data.question_activity !== undefined
  //             ? data.question_activity
  //             : currentPayload.question_activity,
  //         response_activity:
  //           data.response_activity !== undefined
  //             ? data.response_activity
  //             : currentPayload.response_activity,
  //         well_response:
  //           data.well_response !== undefined
  //             ? data.well_response
  //             : currentPayload.well_response,
  //         could_do_better_response:
  //           data.could_do_better_response !== undefined
  //             ? data.could_do_better_response
  //             : currentPayload.could_do_better_response,
  //         activity_2_responses_list:
  //           data.activity_2_responses_list ||
  //           currentPayload.activity_2_responses_list,
  //         activity_3_1st_condition:
  //           data.activity_3_1st_condition !== undefined
  //             ? data.activity_3_1st_condition
  //             : currentPayload.activity_3_1st_condition,
  //         activity_3_2nd_condition:
  //           data.activity_3_2nd_condition !== undefined
  //             ? data.activity_3_2nd_condition
  //             : currentPayload.activity_3_2nd_condition,
  //         index_of_question_answer:
  //           data.index_of_question_answer !== undefined
  //             ? data.index_of_question_answer
  //             : currentPayload.index_of_question_answer,
  //         activity_3_3rd_condition:
  //           data.activity_3_3rd_condition !== undefined
  //             ? data.activity_3_3rd_condition
  //             : currentPayload.activity_3_3rd_condition,
  //         conversation_history_list:
  //           data.conversation_history_list ||
  //           currentPayload.conversation_history_list,
  //         activity_4_1st_condition:
  //           data.activity_4_1st_condition !== undefined
  //             ? data.activity_4_1st_condition
  //             : currentPayload.activity_4_1st_condition,
  //         activity_4_2nd_condition:
  //           data.activity_4_2nd_condition !== undefined
  //             ? data.activity_4_2nd_condition
  //             : currentPayload.activity_4_2nd_condition,
  //         activity_4_condition:
  //           data.activity_4_condition !== undefined
  //             ? data.activity_4_condition
  //             : currentPayload.activity_4_condition,
  //         count: data.count !== undefined ? data.count : currentPayload.count,
  //         evaluation_list:
  //           data.evaluation_list || currentPayload.evaluation_list,
  //         first_response:
  //           data.first_response !== undefined
  //             ? data.first_response
  //             : currentPayload.first_response,
  //         question_1_count:
  //           data.question_1_count !== undefined
  //             ? data.question_1_count
  //             : currentPayload.question_1_count,
  //         satisfaction_condition:
  //           data.satisfaction_condition !== undefined
  //             ? data.satisfaction_condition
  //             : currentPayload.satisfaction_condition,
  //       };

  //       const newProgress = calculateProgress(updatedFlags);
  //       setProgress(newProgress);

  //       // Update the current payload with the new flags and response
  //       setCurrentPayload((prevPayload) => ({
  //         ...prevPayload,
  //         ...updatedFlags,
  //         conversation_list: [...prevPayload.conversation_list, chatbotMessage], // Append chatbot's message to conversation history
  //       }));

  //       // Add the chatbot's message to the messages
  //       const newMessage = {
  //         id: Math.random().toString(),
  //         text: chatbotMessage,
  //         sender: "Chatbot",
  //         direction: "incoming",
  //       };

  //       clearInterval(time);
  //       setMessages((prevMessages) => [...prevMessages, newMessage]);
  //       setTranScript(chatbotConclusion);

  //       // Add response to feedbackResponses
  //       if (chatbotConclusion.trim()) {
  //         setFeedbackResponses((prevFeedback) => [
  //           ...prevFeedback,
  //           {
  //             text: `Feedback ${prevFeedback.length + 1}`,
  //             conclusion: chatbotConclusion,
  //             id: Math.random().toString(), // Unique ID for each feedback
  //           },
  //         ]);
  //       }
  //     } catch (error) {
  //       console.error("Error occurred during the request:", error);
  //       setAnswerload(false);

  //       const errorMessage = {
  //         id: Math.random().toString(),
  //         text: "Something went wrong",
  //         sender: "Chatbot",
  //         direction: "incoming",
  //       };
  //       setMessages((prevMessages) => [...prevMessages, errorMessage]);
  //       clearInterval(time);
  //     }
  //   } else {
  //     setError("Please enter a question");
  //   }
  // };

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");

    if (question.length > 0) {
      timetaken.current = 0;

      // Start timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      // Update the current payload with the new question and conversation list
      const updatedPayload = {
        ...currentPayload, // Get the latest state
        conversation_list: [...currentPayload.conversation_list, question], // Add the question to conversation list
        users_response: question,
      };

      console.log("Payload being sent in the second request:", updatedPayload);

      try {
        // Send the updated payload to the backend
        const response = await fetch(
          "https://h6de6x6e4ova4ubumwtz3cyybm0higet.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedPayload), // Send the updated payload
          },
        );

        const data = await response.json();
        console.log("Second Response Data:", data);

        setAnswerload(false);

        // Extract response message and feedback
        const chatbotMessage = data.message.response || "No message available";
        const chatbotConclusion = data.message.feedback || "";
        // console.log(chatbotConclusion, "111");

        // Only update the flags or fields returned by the backend
        const updatedFlags = {
          // Update only if the backend provides the value, otherwise keep the current value
          welcome_message_event:
            data.message.welcome_message_event !== undefined
              ? data.message.welcome_message_event
              : currentPayload.welcome_message_event,
          start_activity:
            data.message.start_activity !== undefined
              ? data.message.start_activity
              : currentPayload.start_activity,
          activity_1_condition:
            data.message.activity_1_condition !== undefined
              ? data.message.activity_1_condition
              : currentPayload.activity_1_condition,
          activity_2_condition:
            data.message.activity_2_condition !== undefined
              ? data.message.activity_2_condition
              : currentPayload.activity_2_condition,
          activity_3_condition:
            data.message.activity_3_condition !== undefined
              ? data.message.activity_3_condition
              : currentPayload.activity_3_condition,
          question_activity:
            data.message.question_activity !== undefined
              ? data.message.question_activity
              : currentPayload.question_activity,
          response_activity:
            data.message.response_activity !== undefined
              ? data.message.response_activity
              : currentPayload.response_activity,
          well_response:
            data.message.well_response !== undefined
              ? data.message.well_response
              : currentPayload.well_response,
          could_do_better_response:
            data.message.could_do_better_response !== undefined
              ? data.message.could_do_better_response
              : currentPayload.could_do_better_response,
          activity_2_responses_list:
            data.message.activity_2_responses_list ||
            currentPayload.activity_2_responses_list,
          activity_3_1st_condition:
            data.message.activity_3_1st_condition !== undefined
              ? data.message.activity_3_1st_condition
              : currentPayload.activity_3_1st_condition,
          activity_3_2nd_condition:
            data.message.activity_3_2nd_condition !== undefined
              ? data.message.activity_3_2nd_condition
              : currentPayload.activity_3_2nd_condition,
          index_of_question_answer:
            data.message.index_of_question_answer !== undefined
              ? data.message.index_of_question_answer
              : currentPayload.index_of_question_answer,
          activity_3_3rd_condition:
            data.message.activity_3_3rd_condition !== undefined
              ? data.message.activity_3_3rd_condition
              : currentPayload.activity_3_3rd_condition,
          conversation_history_list:
            data.message.conversation_history_list ||
            currentPayload.conversation_history_list,
          activity_4_1st_condition:
            data.message.activity_4_1st_condition !== undefined
              ? data.message.activity_4_1st_condition
              : currentPayload.activity_4_1st_condition,
          activity_4_2nd_condition:
            data.message.activity_4_2nd_condition !== undefined
              ? data.message.activity_4_2nd_condition
              : currentPayload.activity_4_2nd_condition,
          activity_4_condition:
            data.message.activity_4_condition !== undefined
              ? data.message.activity_4_condition
              : currentPayload.activity_4_condition,
          count:
            data.message.count !== undefined
              ? data.message.count
              : currentPayload.count,
          evaluation_list:
            data.message.evaluation_list || currentPayload.evaluation_list,
          first_response:
            data.message.first_response !== undefined
              ? data.message.first_response
              : currentPayload.first_response,
          question_1_count:
            data.message.question_1_count !== undefined
              ? data.message.question_1_count
              : currentPayload.question_1_count,
          satisfaction_condition:
            data.message.satisfaction_condition !== undefined
              ? data.message.satisfaction_condition
              : currentPayload.satisfaction_condition,
        };

        // const newProgress = calculateProgress(updatedFlags);
        // setProgress(newProgress);

        // Merge backend flags and response into the current payload
        // setCurrentPayload((prevPayload) => ({
        //   ...prevPayload,
        //   ...updatedFlags, // Merge flags from backend response
        //   conversation_list: [...prevPayload.conversation_list, chatbotMessage], // Add chatbot message
        // }));

        // Calculate progress directly after updating flags.
        setCurrentPayload((prevPayload) => {
          const mergedPayload = {
            ...prevPayload,
            ...updatedFlags, // Merge flags from backend response
            conversation_list: [
              ...prevPayload.conversation_list,
              chatbotMessage,
            ], // Add chatbot message
          };

          // Calculate progress after merging
          const newProgress = calculateProgress(mergedPayload, progress);
          setProgress(newProgress);
          console.log("Updated Progress: ", newProgress);
          return mergedPayload;
        });

        // Add chatbot message to the UI
        const newMessage = {
          id: Math.random().toString(),
          text: chatbotMessage,
          sender: "Chatbot",
          direction: "incoming",
          feedback: chatbotConclusion,
        };

        clearInterval(time);
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setTranScript(chatbotConclusion);

        // Add feedback conclusion to the feedback list
        if (chatbotConclusion.trim()) {
          setFeedbackResponses((prevFeedback) => [
            ...prevFeedback,
            {
              text: `Feedback ${prevFeedback.length + 1}`,
              conclusion: chatbotConclusion,
              id: Math.random().toString(),
            },
          ]);
        }
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        // Show an error message in the chat
        const errorMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
        clearInterval(time);
      }
    } else {
      setError("Please enter a question");
    }
  };

  const handleFeedbackClick = (response) => {
    setDisplayText(formatResponse(response.conclusion)); // Show the full conclusion in the feedback window
  };

  const [transcription, setTranscription] = useState("");
  const [isRecording, setIsRecording] = useState(false);

  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]);

  const captureAudio = () => {
    if (isRecording) return;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setIsRecording(true);
        const audioContext = new AudioContext({ sampleRate: 16000 });
        audioContextRef.current = audioContext;

        const input = audioContext.createMediaStreamSource(stream);
        const processor = audioContext.createScriptProcessor(4096, 1, 1);
        processorRef.current = processor;
        streamRef.current = stream;

        input.connect(processor);
        processor.connect(audioContext.destination);

        processor.onaudioprocess = (event) => {
          const audioData = event.inputBuffer.getChannelData(0);
          audioChunksRef.current.push(new Float32Array(audioData));
          console.log("Audio chunk received:", audioData.length);
        };

        console.log("Recording started");
      })
      .catch((err) => {
        console.error("Error capturing audio:", err);
      });
  };

  const handleMicrophoneStop = () => {
    if (!isRecording) return;

    if (processorRef.current) {
      processorRef.current.disconnect();
    }
    if (audioContextRef.current) {
      audioContextRef.current.close();
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }

    setIsRecording(false);
    console.log("Recording stopped");

    if (audioChunksRef.current.length === 0) {
      console.error("No audio data captured");
      return;
    }

    const totalLength = audioChunksRef.current.reduce(
      (acc, chunk) => acc + chunk.length,
      0,
    );
    const fullAudioBuffer = new Float32Array(totalLength);
    let offset = 0;
    for (const chunk of audioChunksRef.current) {
      fullAudioBuffer.set(chunk, offset);
      offset += chunk.length;
    }

    console.log("Total audio length (samples):", fullAudioBuffer.length);

    audioChunksRef.current = [];

    // Send the audio buffer for transcription
    sendAudioToServer(fullAudioBuffer).then((transcriptionText) => {
      if (transcriptionText.startsWith("Error")) {
        console.error(transcriptionText);
      } else {
        // Call handleSendMessage with the transcription
        handleSendMessage(transcriptionText);
      }
    });
  };

  const sendAudioToServer = async (fullAudioBuffer) => {
    try {
      const int16Buffer = convertFloat32ToInt16(fullAudioBuffer);
      console.log("Int16 Buffer Length:", int16Buffer.length);

      const base64Audio = arrayBufferToBase64(int16Buffer.buffer);
      console.log("Base64 Audio Length:", base64Audio.length);

      const data = {
        "audio-data": base64Audio,
      };

      const response = await fetch(
        "https://2ebgwsxstddkvpgcehqjrhoflu0lerly.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      const jsonResponse = await response.json();
      console.log("Server Response:", jsonResponse);

      // Updated condition to check if transcription exists
      if (response.ok && jsonResponse.transcription) {
        return jsonResponse.transcription; // Return transcription
      } else {
        // Handling case where transcription doesn't exist or error is reported
        console.error("Error from server:", jsonResponse);
        return `Error processing transcription: ${
          jsonResponse.message || "Unknown error"
        }`;
      }
    } catch (error) {
      console.error("Error sending audio data:", error);
      return `Error sending audio data: ${error.message || "Unknown error"}`;
    }
  };

  const convertFloat32ToInt16 = (buffer) => {
    const int16Buffer = new Int16Array(buffer.length);
    for (let i = 0; i < buffer.length; i++) {
      let s = Math.max(-1, Math.min(1, buffer[i]));
      int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return int16Buffer;
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const handleStart1 = () => captureAudio();
  const handleStop = () => handleMicrophoneStop();

  const handleKeyDown = (e) => {
    if (isInputDisabled) {
      return;
    }
    if ((e.code === "AltLeft" || e.code === "AltRight") && !isRecording) {
      e.preventDefault();
      captureAudio();
    }
  };

  const handleKeyUp = (e) => {
    if (isInputDisabled) {
      return;
    }
    if ((e.code === "AltLeft" || e.code === "AltRight") && isRecording) {
      e.preventDefault();
      handleMicrophoneStop();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [isRecording]);

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        minHeight: "100vh",
        padding: "1rem",
      }}
    >
      {/* <Modal
        open={openPopup}
        onClose={handleClosePopup}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
            width: 800,
            maxWidth: "90%",
          }}
        >
          <Typography variant="h7">
            Welcome {userName}, Today we will learn about Crucial Conversations.
            To recognize a crucial conversation, we need to understand 4
            important tenets:
            <br />
            1. Empathy: Understand and feel the emotions of others during
            high-stakes conversations. Example: "I can see that you're feeling
            frustrated about this decision, and I want to make sure your
            concerns are heard."
            <br />
            2. Active Observation: Pay close attention to the emotional tone,
            body language, and words used. Example: "You seem tense and quiet
            today. Is something about this situation bothering you?"
            <br />
            3. Check for High Stakes: Identify when the outcomes are important
            and could have significant consequences. Example: "The decision we
            make here will affect the entire team's workflow for the next few
            months."
            <br />
            4. Identify Varying Opinions: Notice when people have differing
            views that may affect the decision or outcome. Example: "It seems
            like we have different opinions on the next steps. Can we explore
            both perspectives?"
            <br />
            <strong>
              You will go through MCQs, analyze behavior patterns, solve
              situational questions, and engage in business conversations to
              enhance decision-making and communication skills.
            </strong>
          </Typography>
          <br />
          <br />
          <Button
            onClick={handleClosePopup}
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mx: "auto",
            }}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </Box>
      </Modal> */}

      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Link to={link}>
          <Button variant="contained" component="span" color="primary">
            Back
          </Button>
        </Link>
        <h2 style={{ fontWeight: "bold", color: "#333333" }}>{title}</h2>
        <Button
          style={{
            backgroundColor: "#ffa502",
          }}
          variant="contained"
          onClick={() => {
            signOut();
          }}
          color="primary"
          component="span"
        >
          Sign Out
        </Button>
      </div>

      {/* Main Content Section */}
      {genaiaccess ? (
        <div
          style={{
            display: "flex",
            height: "85vh",
            // gap: "1rem",
            // padding: "1rem",
          }}
        >
          {/* Chat Window (7 parts) */}
          <div
            style={{
              flex: 7,
              backgroundColor: "#F7F8FA",
              padding: "1rem",
              borderRadius: "1rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1.4rem",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Crucial Conversation Business Simulation</strong>
              </h3>
              <Button
                variant="contained"
                color="primary"
                onClick={handleStart}
                style={{ fontSize: "0.9rem", padding: "0.5rem 1rem" }}
              >
                {isStartChatStarted ? "Restart Chat" : "Start Chat"}
              </Button>
            </div>

            <div style={{ position: "relative", width: "100%" }}>
              {/* Linear Progress Bar */}
              <LinearProgress
                variant="determinate"
                value={progress}
                style={{
                  borderRadius: "4px",
                  height: "8px",
                }}
              />

              {/* Text Labels on the Progress Bar */}
              <div
                style={{
                  position: "absolute",
                  top: "0px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "-20px",
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                <span>Basic Theory</span>
                <span>MCQ</span>
                <span>Behaviour Analysis</span>
                <span>Situational Question</span>
                <span>Business Conversation</span>
                <span></span>
              </div>
            </div>
            <MainContainer
              style={{
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.05)",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <ChatContainer
                style={{
                  padding: "1rem",
                  backgroundColor: "#FFFFFF",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  overflow: "hidden",
                }}
              >
                <MessageList
                  style={{
                    color: "#333333",
                    backgroundColor: "#FFFFFF",
                    flexGrow: 1,
                    overflowY: "auto",
                    marginBottom: "1rem",
                    paddingRight: "1rem",
                    maxHeight: "calc(100% - 60px)",
                  }}
                  typingIndicator={
                    answerload && (
                      <TypingIndicator content="chatbot is typing..." />
                    )
                  }
                  autoScrollToBottomOnMount={true}
                >
                  {Array.isArray(messages) &&
                    messages.map((message, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          marginBottom: "1rem",
                          justifyContent:
                            message.direction === "outgoing"
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        {message.direction === "incoming" && (
                          <>
                            <img
                              src="/assets/images/chatbot1.png"
                              alt="Chatbot Icon"
                              style={{
                                marginRight: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                backgroundColor: "#E0E0E0",
                                padding: "0.75rem 1.5rem",
                                borderRadius: "20px 20px 20px 0",
                                maxWidth: "91%",
                                wordWrap: "break-word",
                              }}
                            >
                              <CharacterByCharacter
                                message={message.text}
                                messagesEndRef={messagesEndRef}
                              />
                            </div>
                          </>
                        )}

                        {message.direction === "outgoing" && (
                          <>
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                // backgroundColor: "#6EA9D7 ",
                                backgroundColor: "#9FC8E4",
                                padding: "0.75rem",
                                borderRadius: "20px 20px 0 20px",
                                maxWidth: "70%",
                                wordWrap: "break-word",
                                // textAlign: "right",
                                color: "#333333",
                                marginRight: "0.5rem",
                              }}
                            >
                              {message.text}
                            </div>
                            <img
                              src="/assets/images/man_icon.png"
                              alt="User Icon"
                              style={{
                                marginLeft: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                          </>
                        )}
                      </div>
                    ))}
                  <div ref={messagesEndRef} />
                </MessageList>
                <InputToolbox
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <MessageInput
                    attachButton={false}
                    placeholder="Type your first message here..."
                    // value={transcription}
                    // onChange={(e) => setTranscription(e.target.value)}
                    onSend={(messageText) => {
                      let sanitizedMessage = messageText.replace(
                        /&nbsp;/g,
                        " ",
                      );

                      // Preserve leading spaces with &nbsp;
                      sanitizedMessage = sanitizedMessage.replace(
                        /^\s+/,
                        (match) => {
                          return match
                            .split("")
                            .map(() => "&nbsp;")
                            .join("");
                        },
                      );

                      handleSendMessage(sanitizedMessage.trim());
                    }}
                    disabled={
                      isInputDisabled ||
                      transcript.length > 0 ||
                      currentPayload.satisfaction_condition === true
                    }
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      borderRadius: "8px",
                      backgroundColor: "#F0F2F5",
                      color: "#121212",
                      padding: "0.75rem",
                      border: "1px solid #E0E0E0",
                      boxSizing: "border-box",
                      fontSize: "1rem",
                      width: "95%",
                      position: "relative",
                      zIndex: 10,
                      display: "flex", // Use flexbox
                      alignItems: "center",
                      gap: "10px",
                    }}
                  />
                  <button
                    onClick={isRecording ? handleStop : handleStart1}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: isInputDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={isInputDisabled}
                  >
                    <FontAwesomeIcon
                      icon={isRecording ? faStopCircle : faMicrophone}
                      // icon={faMicrophone}
                      size="lg"
                      color={isRecording ? "red" : "black"}
                    />
                  </button>
                </InputToolbox>
              </ChatContainer>
            </MainContainer>
          </div>

          {/* Right Side (3 parts) */}

          <div
            style={{
              flex: 3,
              fontFamily: "'Outfit', sans-serif",
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Feedback Window</strong>
              </h3>
            </div>
            <div
              style={{
                color: "#333333",
                padding: "1rem",
                border: "1px solid #D1DBE3",
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                flex: 1,
                minHeight: "550px",
                fontSize: "1rem",
                overflowY: "auto",
              }}
            >
              {/* Feedback Buttons */}
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap to the next line
                  gap: "10px", // Optional: Add spacing between buttons
                }}
              >
                {feedbackResponses.map((response, index) => (
                  <Button
                    key={response.id}
                    variant="contained"
                    color="primary"
                    onClick={() => handleFeedbackClick(response)} // Display full feedback on click
                    // style={{
                    //   flex: "1 1 calc(33.33% - 10px)", // Ensure 3 buttons per row with space between
                    //   textTransform: "none",
                    //   marginBottom: "10px", // Spacing between rows
                    // }}
                    style={{
                      flex: "1 1 calc(33.33% - 10px)",
                      textTransform: "none",
                      marginBottom: "10px",
                      width: "100%",
                      minWidth: "120px",
                      maxWidth: "200px",
                      padding: "10px 20px",
                      boxSizing: "border-box",
                    }}
                  >
                    {response.text} {/* Shows Feedback 1, Feedback 2, etc. */}
                  </Button>
                ))}
              </div>

              {displayText.length > 0 ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Response will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "#333333", textAlign: "center" }}>
          You do not have access to use this section.
        </h2>
      )}
    </div>
  );
}

const CharacterByCharacter = ({ message, messagesEndRef }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    const formattedMessage =
      typeof message === "string" ? message : String(message);

    let responseArray = formattedMessage.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + newResponse[currentIndex]);
      currentIndex += 1;
      // Trigger scroll every time a new character is displayed
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (currentIndex === newResponse.length) {
        clearInterval(intervalId);
      }
    }, 1);

    return () => clearInterval(intervalId);
  }, [message, messagesEndRef]);

  return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
};
